import React, { Component }  from 'react';


//componentes
import AppPrincipal from './AppPrincipal';

class  App extends Component {
 
  render() {
    
   return (
      <div className="App">
            <AppPrincipal />         
      </div>
    );
  }
}

export default App;

